module.exports = __webpack_public_path__ + "img/default.3ecb40df.svg";